import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useGetRegisterInfoApi } from '@/api/conference';
import TablePagination from '@/components/common/Pagination/TablePagination';
import ArrowLeftIcon from '@/components/Icon/ArrowLeftIcon';
import { downloadPdf } from '@/utils/fileUtils';

import * as S from './style';

const SocietyConfirm = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const accountTransferMethod = t('society.raw.paymentMethods.accountTransferNoSpace');

	const [page, setPage] = useState(1);
	const { data: registerInfoData } = useGetRegisterInfoApi({
		page: page,
		row: 10,
	});

	const handleBackButton = () => {
		navigate(-1);
	};

	return (
		<S.Container noData={registerInfoData?.register_info?.length === 0}>
			<S.BackButton onClick={handleBackButton}>
				<ArrowLeftIcon iconColor="#01337D" width="16" height="16" />
				<span>{t('society.confirm.back')}</span>
			</S.BackButton>
			{registerInfoData?.register_info?.length !== 0 ? (
				<TablePagination activePage={page} totalItems={registerInfoData?.total_count} onChange={(page) => setPage(page)}>
					<S.TableBox>
						{registerInfoData?.register_info?.map((item, index) => (
							<S.TableItem key={index}>
								<S.TableContent>
									<p className="info">
										{item.pay_info_tran_date} | {t(item.pay_info_pay_method)}
									</p>
									<p>{t(item.pay_info_goods_name)}</p>
								</S.TableContent>
								<S.ButtonBox>
									{item.pay_info_pay_method !== accountTransferMethod && (
										<S.Button type="button" onClick={() => downloadPdf(item.pay_info_pk ?? '', 'receipt')}>
											{t('society.confirm.register.receipt')}
										</S.Button>
									)}
									<S.Button type="button" onClick={() => downloadPdf(item.pay_info_pk ?? '', 'transaction')}>
										{t('society.confirm.register.transaction')}
									</S.Button>
								</S.ButtonBox>
							</S.TableItem>
						))}
					</S.TableBox>
				</TablePagination>
			) : (
				<S.NoData>{t('society.confirm.noData')}</S.NoData>
			)}
		</S.Container>
	);
};

export default SocietyConfirm;
